import ThingsManagerClass from "../../libs/base/ThingsManagerClass";
import PickModalClass from "../common/PickModalClass";
import Util from "../../libs/util/Util";
import PassengersClass from "./PassengersClass";
import CalenderModalClass from "../common/CalenderModalClass";
import AirportSelectModalClass from "./AirportSelectModalClass";
import dayjs from 'dayjs';
import LtikeCommon from "../common/LtikeCommon";
import gsap from "gsap";
import RippleManagerClass from "../common/RippleManagerClass";

/**
 * 航空券　検索枠　管理
 */
export default class TicketSearchAreaClass extends ThingsManagerClass{
    constructor(_parent){
        super();
        this.name = "TicketSearchAreaClass";

        this.CL_LOADING = "isLoading";

        this.CL_ONEWAY = "isOneWay";

        this.parent = _parent;

        this.isSwitchAnimation = false;
        this.onClickAirportSwitchListener = this.onClickAirportSwitch.bind(this);

        this.onChangeRoundListener = this.onChange_round.bind(this);

        this.onSubmitListener = this.onSubmit.bind(this);
    }

    onCreate() {
        this.things = {};

        this.target = $('[data-id="search_airplane"]',this.parent);
        this.target.css({display:"block"});

        this.error = $('[data-type="submit_error"]',this.target);

        this.things.calenderModal = new CalenderModalClass("calender",this.parent);
        this.things.calenderModal.DEFAULT_DATE = {
            point1:LtikeCommon.AIRPLANE.DEFAULT_DATE.going,
            point2:LtikeCommon.AIRPLANE.DEFAULT_DATE.back
        };
        this.things.departure = new AirportSelectModalClass("departure",this.parent);
        this.things.arrive = new AirportSelectModalClass("arrive",this.parent);

        this.things.departure.on(this.things.departure.EVENT_CHANGE,(e,d)=>{
            const selectCode = this.things.departure.code;
            console.log("departure",selectCode);
            this.setArriveAirport(selectCode);
        });
        this.things.arrive.on(this.things.arrive.EVENT_CHANGE,(e,d)=>{
            const selectCode = this.things.arrive.code;
            console.log("arrive",selectCode);
            this.onSetCalenderPrice();
        });

        this.dateBack = $('[data-target="calender"] [data-type="back"]',this.target);

        this.things.passengersModal = new PickModalClass("passengers",this.parent);
        this.things.passengers = new PassengersClass(".pick_modal[data-id=passengers]",this.parent);
        this.things.passengersModal.on(this.things.passengersModal.EVENT_BEFORE_POSITIVE,()=>{
            this.onSetPcPassengerButtonText();
        });
        this.things.passengersModal.on(this.things.passengersModal.EVENT_POSITIVE,()=>{
            this.things.passengers.onPositive();
        });
        this.things.passengersModal.on(this.things.passengersModal.EVENT_NEGATIVE,()=>{
            this.things.passengers.onNegative();
        });
        this.things.passengersModal.on(this.things.passengersModal.EVENT_CLOSE,()=>{
            this.things.passengers.onNegative();
        });

        $('[data-type="airport_switch"]',this.target).on("click",this.onClickAirportSwitchListener);

        this.airportDepartureText = $("[data-target=\"departure\"] .text",this.target);
        this.airportArriveText = $("[data-target=\"arrive\"] .text",this.target);

        this.form = $("form",this.target);
        this.form.on("submit",this.onSubmitListener);

        this.methoditineraryRadio = $('input[name=methoditinerary]',this.target);
        this.methoditineraryRadio.on("change",this.onChangeRoundListener);

        super.onCreate();
    }

    onChangeBreakPoint(b) {
        super.onChangeBreakPoint(b);

        //console.log("onChangeBreakPoint0",this.things.calenderModal,this.things.calenderModal.things.calender,Util.MASTER_AIRPLANE_TICKET);
        if(!this.things.calenderModal || !this.things.calenderModal.things.calender || !Util.MASTER_AIRPLANE_TICKET) return;
        //console.log("onChangeBreakPoint");
        this.things.calenderModal.onClose(this.EVENT_NEGATIVE);
        this.things.calenderModal.things.calender.isSlide = (!Util.isBreakpoint);
        this.onSetData();

    }

    onClickAirportSwitch(e){
        e.preventDefault();

        if(this.isSwitchAnimation) return;
        this.isSwitchAnimation = true;

        let dCode = this.airportDepartureText.attr("data-id");
        let aCode = this.airportArriveText.attr("data-id");
        if(!dCode || !aCode) {
            this.isSwitchAnimation = false;
            return;
        }

        const departText = this.airportDepartureText.text();
        const arriveText = this.airportArriveText.text();

        if(!dCode) dCode = "";
        if(!aCode) aCode = "";
        this.setArriveAirport(aCode);

        this.airportDepartureText.text(arriveText).attr({"data-id":aCode});
        this.airportArriveText.text(departText).attr({"data-id":dCode});
        this.things.departure.code = aCode;
        this.things.arrive.code = dCode;
        this.things.departure.onActiveChange();
        this.things.arrive.onActiveChange();

        this.onSetCalenderPrice();

        const $icon = $(".icon",$(e.currentTarget));
        gsap.to($icon,{duration:0.2,rotation:"180deg",ease:"power2.out",onComplete:()=>{
                gsap.set($icon,{rotation:"0deg"});
                this.isSwitchAnimation = false;
            }
        });


    }

    onChange_round(e){
        const val = $(e.currentTarget).val();
        this.onSelectRound(parseInt(val));
    }

    onSelectRound(_v){
        //console.log(this.name,"onSelectRound",_v);
        if(_v === 2){
            //往復
            this.dateBack.css({display:""});
            this.things.calenderModal.setOneWay(false);
            this.target.removeClass(this.CL_ONEWAY);
        } else if(_v === 1){
            //片道
            this.dateBack.css({display:"none"});
            this.things.calenderModal.setOneWay(true);
            this.target.addClass(this.CL_ONEWAY);
        }
        $(window).trigger("resize");
    }

    onSetData() {
        this.airportData = Util.MASTER_AIRPORT_DATA;
        this.priceList = Util.MASTER_AIRPLANE_PRICE_LIST;
        this.things.calenderModal.onSetData(Util.MASTER_AIRPLANE_TICKET.calender_term);

        this.things.departure.onSetDefaultSelect();
        this.things.arrive.onSetDefaultSelect();

        const isOneWay = (parseInt($('input[name=methoditinerary]:checked',this.target).val()) === 1);
        if(isOneWay){
            //片道
            this.onSelectRound(1);
        }

        this.onSetCalenderPrice();
    }

    onSetCalenderPrice(){
        const dCode = this.things.departure.code;
        const aCode = this.things.arrive.code;
        let price = Util.getPriceList(dCode,aCode);
        this.things.calenderModal.onSetPrice(price);
    }

    onSubmit(e){
        //console.log(this.name,"onSubmit",e);

        //往復か片道か設定
        const methoditinerary = parseInt(this.methoditineraryRadio.filter(':checked').val());

        //出発地と目的地をチェック
        const dCode = this.things.departure.code;
        const aCode = this.things.arrive.code;
        //console.log(this.name,"onSubmit",dCode,aCode);
        if(!dCode) {
            e.preventDefault();
            this.onSubmitError(LtikeCommon.AIRPLANE.TEXT.SEARCH_SUBMIT_ERROR_DEPARTURE);
            return;
        }
        if(!aCode) {
            e.preventDefault();
            this.onSubmitError(LtikeCommon.AIRPLANE.TEXT.SEARCH_SUBMIT_ERROR_DESTINATION);
            return;
        }

        //搭乗者チェック
        const passengers = this.things.passengers.onCheckSubmitError();
        //console.log(this.name,"onSubmit - passengers",passengers);
        if(passengers.isError) {
            e.preventDefault();
            this.onSubmitError(passengers.msg);
            return;
        }

        const adtnum = $('[name=adtnum]',this.form);
        const chdnum = $('[name=chdnum]',this.form);
        const chdage = $('[name=chdage]',this.form);

        //人数セット
        adtnum.val(passengers.data.adult);
        chdnum.val(passengers.data.child);
        chdage.val(passengers.data.ageList.join(","));


        //日付と行き先を設定
        const seg = $('[name=seg]',this.form);
        const calenderData = this.things.calenderModal.getData();

        let segVal = dCode+'-'+aCode+'-'+calenderData.going;
        if(methoditinerary === 2){
            //往復
            segVal += ','+aCode+'-'+dCode+'-'+calenderData.back;
        }
        //console.log(this.name,"onSubmit",segVal,methoditinerary);
        seg.val(segVal);
        this.error.css({display:""});


        let params = {
            airport:{
                from:dCode,
                to:aCode
            },
            date:{
                going:calenderData.going,
                back:calenderData.back
            },
            methoditinerary:methoditinerary,
            passengers:{
                adult:passengers.data.adult,
                ageList:passengers.data.ageList
            }
        };
        Util.localstrageSetItem(Util.LOCALSTORAGE_KEY_AIRPLANE_SEARCH_PARAMS,JSON.stringify(params));
        //e.preventDefault();
    }

    onSubmitError(msg){
        //console.log(this.name,"onSubmitError",msg);
        $("p",this.error).text(msg);
        this.error.css({display:"block"});
    }

    onSetDefaultData(_json){
        //const data = Util.MASTER_AIRPORT_DATA;//JSON.parse(Util.sessionStorageGetItem(Util.SESSION_KEY_MASTER_AIRPLANE_TICKET));
        let passengers = {adult:1,ageList:[]};
        if(_json){

            const airport = Util.MASTER_AIRPORT_DATA;//data.getdomesticairport.item;
            //console.log(airport);
            //出発地を選択状態に
            if(_json.from) {
                let from = null;
                for(let k in airport){
                    const d = airport[k];
                    if(d.code === _json.from){
                        from = d;
                        break;
                    }
                }
                //console.log("onSetDefaultData",from);
                if(from){
                    this.things.departure.onSetData(from);
                    this.setArriveAirport(from.code);
                }
            }
            //目的地を選択状態に
            if(_json.to){
                let to = null;
                for(let k in airport){
                    const d = airport[k];
                    if(d.code === _json.to){
                        to = d;
                        break;
                    }
                }
                //console.log("onSetDefaultData",to);
                if(to){
                    this.things.arrive.onSetData(to);
                    this.setDepartureAirport(to.code);
                }
            }


            if(_json.passengers){
                passengers = _json.passengers;
            }
        }

        this.things.passengers.onSetData(passengers);
        this.onSetPcPassengerButtonText();

        this.target.removeClass(this.CL_LOADING);
    }

    /*onSetDefaultData(){
        if(!Util.AIRPLANE_SEARCH_PARAMS || !Util.AIRPLANE_SEARCH_PARAMS.detail){
            this.things.calenderModal.onSetDate({
                going:dayjs(Util.MASTER_AIRPLANE_TICKET.calender_term.calender_start).add(LtikeCommon.AIRPLANE.DEFAULT_DATE.going,"d"),
                back:dayjs(Util.MASTER_AIRPLANE_TICKET.calender_term.calender_start).add(LtikeCommon.AIRPLANE.DEFAULT_DATE.back,"d")
            });
            return;
        }

        const _data = Util.AIRPLANE_SEARCH_PARAMS.detail;

        console.log(this.name,"onSetDefaultData",_data);

        let isOneWay = _data.isOneWay;
        if(isOneWay){
            //片道
            this.onSelectRound(1);
            this.methoditineraryRadio.filter('[value=1]').prop("checked",true);
        } else {
            //往復
            this.onSelectRound(2);
            this.methoditineraryRadio.filter('[value=2]').prop("checked",true);
        }

        //出発地を選択状態に
        this.things.departure.onSetData(_data.airport.from);

        this.setArriveAirport(_data.airport.from.code);

        //目的地を選択状態に
        this.things.arrive.onSetData(_data.airport.to);

        //カレンダーを設定
        const date = {going:_data.date.going,back:_data.date.back,isOneWay:isOneWay};
        this.things.calenderModal.onSetDate(date);
        this.onSetCalenderPrice();

        //搭乗者を反映
        this.things.passengers.onSetData(_data.passengers);
        this.onSetPcPassengerButtonText();

        if(Util.isBreakpoint){
            const $conditions = $(".section_conditions");
            const point1Data = _data.airport.from;
            const point2Data = _data.airport.to;
            $(".from_to .from",$conditions).text(point1Data.disp_name);
            $(".from_to .to",$conditions).text(point2Data.disp_name);
            $(".other .t",$conditions).text((isOneWay)? "片道" : "往復");
            $(".other .n",$conditions).text(_data.passengers.adult+_data.passengers.ageList.length);
        }
    }*/

    onSetAirport(_from,_to){
        //出発地を選択状態に
        this.things.departure.onSetData(_from);

        this.setArriveAirport(_from.code);

        //目的地を選択状態に
        this.things.arrive.onSetData(_to);
    }

    onSetCalender(_data){
        this.things.calenderModal.onSetDate(_data);
    }

    onSetPcPassengerButtonText(){
        const text = "大人"+this.things.passengers.adult.n+"名,子供"+this.things.passengers.child.n+"名";
        this.things.passengersModal.onSetClickTargetText(text);
    }

    setArriveAirport(_code){
        //目的地のリストを作成
        const data = Util.MASTER_AIRPORT_DATA[_code];
        let items = null;
        if(data) {
            items = data.arrlist.arritem;
        }
        //console.log(this.name,"setArriveAirport",data,items);
        this.things.arrive.onSetSelect(items);
    }

    setDepartureAirport(_code){
        //目的地のリストを作成
        const data = Util.MASTER_AIRPORT_DATA[_code];
        let items = null;
        if(data) {
            items = data.arrlist.arritem;
        }
        console.log(this.name,"setDepartureAirport",data,items);
        this.things.departure.onSetSelect(items);
    }

}